/* eslint-disable no-undef */
/* eslint-disable eqeqeq */
function launch(hasCommand) {
  // eslint-disable-next-line no-undef
  const UserAgent = new UAParser();
  if ((UserAgent.getOS().name || '').match(/Android/)) {
    // Android
    if (no_app_redirect_url) {
      setTimeout(function () {
        if (!document.webkitHidden) window.location = no_app_redirect_url;
      }, 500);
    }

    if (hasCommand) {
      document.getElementById('intent').click();
    }
  }
}

/* from https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API */
let hidden;
let visibilityChange;
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

function supportsVisibilityApi() {
  return typeof document[hidden] !== 'undefined';
}

function isDocumentHidden() {
  return document[hidden] === true || document[hidden] === 'hidden';
}

function onDocumentIsVisible(callback) {
  if (!isDocumentHidden()) {
    callback();
    return;
  }
  document.addEventListener(
    visibilityChange,
    function _onDocumentVisible() {
      if (!isDocumentHidden()) {
        document.removeEventListener(visibilityChange, _onDocumentVisible, false);
        callback();
      }
    },
    false,
  );
}

function runCommand() {
  let path = document.location.hash;
  // Facebook links sometimes contain "#_=_" at the end, which we want to ignore (MOBILE-6499)
  if (document.location.pathname == '/' && path && path.length > 2 && path != '#_=_') {
    // if a /#/ url hits the landing page, lop off the /# and reload the page
    if (path.indexOf('#!') == 0) {
      path = path.substr(2);
    } else if (path.indexOf('#') == 0) {
      path = path.substr(1);
    }
    window.location.href = path + '?_sl_referrer=' + encodeURIComponent(document.referrer);
  } else {
    // hasCommand is set from velocity to JS variable in index.vm
    launch(hasCommand);
  }
}

function onLoad() {
  if (!supportsVisibilityApi() || !isDocumentHidden()) {
    runCommand();
    return;
  }
  onDocumentIsVisible(runCommand);
}

document.body.onload = onLoad;
